























import { Vue, Component } from 'vue-property-decorator';

import UnorderedList from '@/components/Atoms/List/UnorderedList.vue';
import ListItem from '@/components/Atoms/ListItem/ListItem.vue';
import RadioButton from '@/components/Atoms/Input/RadioButton.vue';
import Price from '@/components/Atoms/Text/Price.vue';

@Component({
  components: {
    UnorderedList,
    ListItem,
    RadioButton,
    Price,
  },
})
// 現在、無線LAN機能付きのルーターをレンタルしていますか。
export default class CurrentRentalWifiRouter extends Vue {
  public selectRadioList: { id: string; text: string, price: number }[] = [
    {
      id: 'current_phone_wireless_router_rental',
      text: '無線LAN機能付きのルーターをレンタルしている　',
      price: 300,
    },
    {
      id: 'current_phone_not_wireless_router_rental',
      text: '無線LAN機能なしのルーターをレンタルしている　',
      price: 200,
    },
  ];
  mounted() {
    const value = this.$store.getters['hikari/router']
    if (value === 'current_phone_wireless_router_rental' || value === 'current_phone_not_wireless_router_rental') {
      this.$store.commit(`hikari/router`, value);
    } else {
      this.$store.commit(`hikari/router`, 'current_phone_wireless_router_rental');
    }
  }
}
